// extracted by mini-css-extract-plugin
module.exports = {"container":"BookSelectGroup_container__gakjv","divider":"BookSelectGroup_divider__31Vxq"};